export default __webpack_public_path__ + "images/e89d95b10364eee3e454fc9946c9f046.svg";